import DashboardsProvider, {
    DashboardsContext,
    OverviewQueryTitles,
    DisplayQueryTitles,
    CompanyInfoFields,
    OverviewQueries,
    OverviewQueriesList,
    StatusGroupList,
  } from "./DashboardsProvider";

export type { OverviewQueries, OverviewQueriesList, StatusGroupList };

export { OverviewQueryTitles, DisplayQueryTitles, CompanyInfoFields };

export { DashboardsContext };

export default DashboardsProvider;